export const mainIntroduceText = "此工具用于协助记录游戏中的一些信息，比如配队、阵容等；<br>需要自己通过上传对应截图，或者加入同盟以查看盟友上传的截图信息。<br><br><span style='color: red;'>注意事项：<br>1.所有以这个软件的客服或运营私下添加任何平台的账号的人都是诈骗！<br>2.此平台不会主动申请添加任何用户！<br>3.切勿上传任何和个人隐私相关的任何图片！<br>4.平台不会主动收录用户任何信息！</span><br><br><span style='color: #044a90;'>有任何问题或建议联系邮件：<br>1920192401@qq.com</span>";

export const uploadReportText = "由于平台储存空间有限，非VIP用户上传的图片，有效期仅为30天，到期后自动删除！VIP及SVIP延长图片有效期。<br><br>";

export const searchText = "由于平台储存空间有限，非VIP用户上传的图片，有效期仅为30天，到期后自动删除！SVIP可跨同盟查看上传的截图！<br><br>";

export const obtainLabel = [
    "待支付",
    "支付中",
    "已支付",
    "已过期",
    "已失效",
    "已退款",
    "问题件"
];

export const processPageConfig = {
    'options': [
        {
            value: '请选择',
            label: '请选择'
        },
        {
            value: '待支付',
            label: '待支付'
        },
        {
            value: '支付中',
            label: '支付中'
        },
        {
            value: '已支付',
            label: '已支付'
        },
        {
            value: '已过期',
            label: '已过期'
        },
        {
            value: '已失效',
            label: '已失效'
        },
        {
            value: '已退款',
            label: '已退款'
        },
        {
            value: '问题件',
            label: '问题件'
        }
    ],
    'appDataDisplay_header': [
        {'name':'Orderstate', 'index':1, 'label':'订单状态'},
        {'name':'Howmuch', 'index':2, 'label':'金额'},
        {'name':'ApplicationUser', 'index':3, 'label':'用户'},
        {'name':'Remarks', 'index':4, 'label':'备注'},
        {'name':'LicenseKey', 'index':5, 'label':'授权码'},
        {'name':'Operationuser', 'index':6, 'label':'操作员'}
    ]
}

export const appCreatOrderConfig = {
    "typeform_select": [
        {
            value: '率土',
            label: '率土'
        },
        {
            value: '小程序',
            label: '小程序'
        },
        {
            value: '后台',
            label: '后台'
        },
        {
            value: '其他',
            label: '其他'
        }
    ]
}

export const followTags = [];

export const queryTags = [];

export const creatMenuData_pc = [{ 'index': 1, 'icon': '', 'name': '菜单管理', 'children': [], 'Route': 'MenuPage'}];

export const htTilte = '后台管理系统';

